<template>
  <v-dialog :value="value" max-width="640px" persistent @keydown.esc="close">
    <v-card>
      <v-card-title>Är du där?</v-card-title>

      <v-card-text>
        Du har varit inaktiv för länge och loggas därför ut om
        {{ secondsLeft }} sekunder.
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="stay">
          <v-icon small>mdi-lightbulb-on</v-icon>
          Fortsätt vara inloggad
        </v-btn>
        <v-btn @click="logout">
          <v-icon>$logout</v-icon>
          Logga ut
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmLogoutDialog",
  props: {
    value: {
      type: Boolean,
    },
    remaining: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      secondsLeft: 0,
      interval: null,
    };
  },
  methods: {
    stay() {
      this.$emit("stay");
    },
    logout() {
      this.$emit("logout");
    },
    close() {
      this.$emit("input", false);
    },
  },
  watch: {
    value(state) {
      clearInterval(this.interval);
      if (!state) return;
      const deadline = Date.now() + this.remaining;
      const update = () => {
        this.secondsLeft = Math.max(
          0,
          Math.ceil((deadline - Date.now()) / 1000)
        );
      };
      update();
      this.interval = setInterval(update, 1000);
    },
  },
  beforeDestroy () {
    clearInterval(this.interval);
  }
};
</script>
